import { render, staticRenderFns } from "./HeatmapLoader.vue?vue&type=template&id=2b49c0c6&"
import script from "./HeatmapLoader.vue?vue&type=script&lang=js&"
export * from "./HeatmapLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports